// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/product.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Images/galery.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.Uav_uav__TLbUm {
  width: 100%;
  max-width: 100%;
  position: relative;
  height: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  overflow-x: hidden;
}

.Uav_uav-section-one__\\+qXXF {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

@keyframes Uav_fadeInMini__fPncr {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 0.7;
    transform: translateY(0);
  }
}
.Uav_mini-image__-af0C {
  position: absolute;
  width: 240px;
  height: auto;
  opacity: 0;
  pointer-events: none;
  z-index: 5;
  animation: Uav_fadeInMini__fPncr 1s ease forwards;
}

.Uav_top-right__Nfiv6 {
  top: -3px;
  right: 20px;
}

.Uav_bottom-right__fFdas {
  bottom: 20px;
  right: 20px;
}

.Uav_navbar-uav__tUjXS {
  transition: background 0.5s ease;
  display: flex;
  width: 100%;
}

.Uav_uav-section-one__\\+qXXF {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  transition: background 0.5s ease;
  box-sizing: border-box;
  margin-top: -2px;
}

.Uav_uav-image__9H7C4 {
  width: 100%;
  max-width: 1400px;
  height: 700px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right center;
  aspect-ratio: 16/9;
  transition: background-image 0.5s ease;
}

.Uav_uav-paragraphs__W5BBQ {
  width: 85%;
  color: white;
  margin-left: 100px;
  font-size: 1.2rem;
  text-align: start;
  align-self: start;
  border-radius: 8px;
  display: flex;
}

.Uav_uav-paragraphs__W5BBQ p {
  font-weight: 700;
  font-size: 48px;
  line-height: 100%;
  margin-top: -150px;
  font-family: "Roboto", sans-serif;
}

.Uav_uav-paragraphs__W5BBQ h1 {
  font-size: 64px;
  font-weight: 700;
  line-height: 100%;
  margin-left: 40px;
  font-family: "Roboto", sans-serif;
}

/* Background gradients */
.Uav_bg-one__hc\\+eg {
  background-image: url("https://i.imgur.com/0CBAAgA.png");
  background-size: cover;
  background-repeat: no-repeat;
}

.Uav_bg-two__RGggm {
  background-image: url("https://i.imgur.com/0CBAAgA.png");
  background-size: cover;
  background-repeat: no-repeat;
}

.Uav_bg-three__GIOuW {
  background-image: url("https://i.imgur.com/0CBAAgA.png");
  background-size: cover;
  background-repeat: no-repeat;
}

.Uav_bg-for__F2shc {
  background-image: url("https://i.imgur.com/0CBAAgA.png");
  background-size: cover;
  background-repeat: no-repeat;
}

.Uav_bg-five__1G\\+Hm {
  background-image: url("https://i.imgur.com/0CBAAgA.png");
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.9;
}

.Uav_bg-six__uHuTC {
  background-image: url("https://i.imgur.com/0CBAAgA.png");
  background-size: cover;
  background-repeat: no-repeat;
}

.Uav_uav-section-one__\\+qXXF {
  background-image: url("https://i.imgur.com/Yrm4coY.png");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
}

.Uav_bg-seven__wsXia {
  background-image: url("https://i.imgur.com/0CBAAgA.png");
  background-size: cover;
  background-repeat: no-repeat;
}

.Uav_uav-section-one__\\+qXXF {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Uav_uav-background__G1gbr {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.Uav_uav-paragraph__h1CSA {
  width: 70%;
  margin: auto;
  margin-top: 100px;
  margin-bottom: 200px;
}

.Uav_uav-paragraph__h1CSA p {
  font-weight: 400;
  font-size: 30px;
  color: #252626;
  line-height: 1.2;
  font-family: "Roboto", sans-serif;
  text-align: justify;
}

.Uav_product-section__yTo1h button:hover {
  background-color: white;
  color: #191A1A;
}

.Uav_aw-5-section__2Qf\\+u button:hover {
  background-color: white;
  color: #4C6D59;
}

.Uav_aw-6-section__QuKsS button:hover {
  background-color: #4C6D59;
  color: white;
}

.Uav_section__zL39E {
  width: 80%;
  margin: auto;
  height: 70vh;
  margin-top: 200px;
  background-color: rgba(37, 38, 38, 0.6980392157);
  position: relative; /* Enable absolute positioning inside */
}

.Uav_aw5-horizonal-image__EjAYM {
  width: 370px;
  height: 360px;
  background-image: url("https://i.imgur.com/9RhiUYc.png");
  background-size: contain;
  background-repeat: no-repeat;
  transform: scaleX(1); /* Optional: Flip image if needed */
  position: absolute;
  top: -40px;
  right: -180px;
}

.Uav_slider-section__yrVA- {
  width: 80%;
  margin: auto;
  height: auto;
  margin-top: -85px;
  margin-bottom: 100px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  z-index: 99;
  position: relative;
}

.Uav_aw-5-section__2Qf\\+u {
  width: 400px;
  margin: auto;
  border-radius: 16px;
  background: #4C6D59;
  border: solid 3px white;
  margin-bottom: 25px;
}

.Uav_aw-5-section__2Qf\\+u p {
  font-size: 46px;
  margin-left: 50px;
  margin-top: 40px;
  font-weight: 700;
  color: #ffffff;
  font-family: "Roboto", sans-serif;
}

.Uav_aw-5-section__2Qf\\+u img {
  width: 100%;
  height: 250px;
  background-size: contain;
  background-position: center;
}

.Uav_aw-5-section__2Qf\\+u button {
  margin-left: 40px;
  width: 80%;
  border-radius: 32px;
  border: 2px solid white;
  color: white;
  background-color: #4C6D59;
  font-size: 32px;
  font-family: "Roboto", sans-serif;
  margin-bottom: 20px;
  font-weight: 500;
}

.Uav_aw-6-section__QuKsS {
  width: 400px;
  border-radius: 16px;
  margin: auto;
  background: white;
  border: solid 3px #4C6D59;
  margin-bottom: 25px;
}

.Uav_aw-6-section__QuKsS p {
  font-size: 46px;
  font-weight: 700;
  margin-left: 50px;
  margin-top: 40px;
  color: #4C6D59;
  font-family: "Roboto", sans-serif;
}

.Uav_aw-6-section__QuKsS img {
  width: 400px;
  height: 250px;
  background-size: contain;
}

.Uav_aw-6-section__QuKsS button {
  margin-left: 40px;
  width: 80%;
  border-radius: 32px;
  border: 2px solid #4C6D59;
  background-color: white;
  font-size: 32px;
  font-family: "Roboto", sans-serif;
  margin-bottom: 20px;
  color: #4C6D59;
  font-weight: 500;
}

@media (max-width: 1000px) {
  .Uav_uav-section-one__\\+qXXF {
    height: 700px;
  }
  .Uav_uav-image__9H7C4 {
    max-width: 100%;
    aspect-ratio: 25/10;
    background-position: center;
  }
  .Uav_mini-image__-af0C {
    width: 160px;
  }
  .Uav_uav-paragraphs__W5BBQ p {
    font-size: 32px;
  }
  .Uav_uav-paragraphs__W5BBQ h1 {
    font-size: 48px;
  }
  .Uav_uav-paragraphs__W5BBQ {
    display: flex;
    justify-content: center;
    margin-left: 0px;
    padding-top: 60px;
    width: 100%;
  }
}
.Uav_product-section__yTo1h {
  width: 80%;
  height: 113px;
  display: flex;
  margin: auto;
  background-color: #252626;
  margin-bottom: 100px;
  justify-content: space-around;
  align-items: center;
  flex-wrap: nowrap;
}

.Uav_product-section__yTo1h span {
  color: white;
  font-weight: 700;
  font-size: 32px;
  line-height: 100%;
  font-family: "Roboto", sans-serif;
}

.Uav_product-section__yTo1h button {
  width: 300px;
  height: 66px;
  border-radius: 32px;
  border: solid white;
  background-color: #252626;
  color: white;
  font-size: 32px;
  font-weight: 700;
  cursor: pointer;
}

.Uav_product-icons-section__UlYst {
  max-width: 800px;
  width: 100%;
  height: 100%;
  display: flex;
}

.Uav_product-icon__Llkim {
  width: 115px;
  height: 101px;
  left: 362px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  margin: auto;
  padding-top: 70px;
}

.Uav_galery-icon__7FpwZ {
  width: 115px;
  height: 101px;
  left: 362px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  margin: auto;
  padding-top: 70px;
}

.Uav_aw5-section__hS5St {
  width: 60%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
}

.Uav_aw-5-image__UVwPt {
  width: 60%;
  height: 100%;
  background-image: url("https://i.imgur.com/onyLX1j.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right center;
}

.Uav_product-icon__Llkim p {
  color: #4C6D59;
  font-weight: 700;
  font-size: 36px;
}

.Uav_product-icon__Llkim a {
  list-style: none;
  text-decoration: none;
}

.Uav_galery-icon__7FpwZ p {
  color: #4C6D59;
  font-weight: 700;
  font-size: 36px;
}

@media (max-width: 1800px) {
  .Uav_uav__TLbUm {
    width: 1800px;
  }
}
@media (max-width: 1000px) {
  .Uav_product-section__yTo1h span {
    font-size: 16px;
    margin-bottom: 20px;
    margin-top: 22px;
  }
  .Uav_product-section__yTo1h button {
    font-size: 16px;
    height: 32px;
    width: 100px;
  }
  .Uav_uav-paragraph__h1CSA p {
    font-size: 24px;
  }
  .Uav_uav-paragraphs__W5BBQ p {
    margin-left: -10px;
  }
  .Uav_aw-5-section__2Qf\\+u {
    width: 210px;
  }
  .Uav_aw-5-section__2Qf\\+u p {
    font-size: 24px;
  }
  .Uav_aw-5-section__2Qf\\+u button {
    width: 120px;
    font-size: 18px;
    margin-left: 40px;
    margin-top: 30px;
    height: 30px;
  }
  .Uav_aw-5-section__2Qf\\+u img {
    width: 200px;
    height: 150px;
    margin-left: 7px;
  }
  .Uav_aw-6-section__QuKsS {
    width: 210px;
  }
  .Uav_aw-6-section__QuKsS p {
    font-size: 24px;
  }
  .Uav_aw-6-section__QuKsS button {
    width: 120px;
    font-size: 18px;
    margin-left: 40px;
    margin-top: 30px;
    height: 30px;
  }
  .Uav_aw-6-section__QuKsS img {
    width: 200px;
    height: 150px;
  }
  .Uav_product-icons-section__UlYst {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: auto;
    gap: 20px; /* icon-ների միջև տարածություն */
    margin-bottom: 20px;
  }
  .Uav_product-icon__Llkim,
  .Uav_galery-icon__7FpwZ {
    width: 75px;
    height: 65px;
    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 0;
    margin-bottom: 50px;
    margin-top: 40px;
  }
  .Uav_product-icon__Llkim p,
  .Uav_galery-icon__7FpwZ p {
    font-size: 24px;
    text-align: center;
    margin-top: 150px;
  }
  .Uav_aw5-section__hS5St {
    width: 100%;
    justify-content: center;
  }
  .Uav_aw-5-image__UVwPt {
    width: 80%;
    height: 300px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
}
@media (max-width: 600px) {
  .Uav_uav-section-one__\\+qXXF {
    height: 60vh;
  }
  .Uav_uav-paragraphs__W5BBQ p {
    font-size: 18px;
    padding-top: 65px;
  }
  .Uav_uav-paragraphs__W5BBQ h1 {
    font-size: 28px;
  }
  .Uav_uav-paragraph__h1CSA p {
    font-size: 20px;
    margin-top: -50px;
  }
  .Uav_uav-section-one__\\+qXXF {
    height: 250px;
  }
}
.Uav_aw-5-section__2Qf\\+u, .Uav_aw-6-section__QuKsS {
  transition: transform 0.7s ease;
  transform-style: preserve-3d;
  backface-visibility: hidden;
  cursor: pointer;
}
.Uav_aw-5-section__2Qf\\+u:hover, .Uav_aw-6-section__QuKsS:hover {
  transform: rotateY(20deg);
  box-shadow: 10px 10px 10px silver;
  cursor: pointer;
}

button:hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Uav/Uav.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAEF;;AAIA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AADF;;AAKA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AAFF;;AAMA;EACE;IACE,UAAA;IACA,4BAAA;EAHF;EAKA;IACE,YAAA;IACA,wBAAA;EAHF;AACF;AAMA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,UAAA;EACA,iDAAA;AAJF;;AAQA;EACE,SAAA;EACA,WAAA;AALF;;AAQA;EACE,YAAA;EACA,WAAA;AALF;;AASA;EACE,gCAAA;EAEA,aAAA;EACA,WAAA;AAPF;;AAWA;EACE,WAAA;EAEA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,qBAAA;EACA,gCAAA;EACA,sBAAA;EACA,gBAAA;AATF;;AAYA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EAEA,wBAAA;EACA,4BAAA;EACA,iCAAA;EACA,kBAAA;EACA,sCAAA;AAVF;;AAaA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EAGA,aAAA;AAZF;;AAiBA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCAAA;AAdF;;AAiBA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iCAAA;AAdF;;AAiBA,yBAAA;AACA;EAIE,wDAAA;EACA,sBAAA;EACA,4BAAA;AAjBF;;AA0BA;EACE,wDAAA;EACA,sBAAA;EACA,4BAAA;AAvBF;;AA2BA;EAME,wDAAA;EACA,sBAAA;EACA,4BAAA;AA7BF;;AAkCA;EACE,wDAAA;EACA,sBAAA;EACA,4BAAA;AA/BF;;AAoCA;EAIE,wDAAA;EACA,sBAAA;EACA,4BAAA;EACA,YAAA;AApCF;;AAuCA;EAEE,wDAAA;EACA,sBAAA;EACA,4BAAA;AArCF;;AAyCA;EACE,wDAAA;EACA,sBAAA;EACA,4BAAA;EACA,gBAAA;AAtCF;;AAyCA;EAGE,wDAAA;EACA,sBAAA;EACA,4BAAA;AAxCF;;AA8CA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA3CF;;AA8CA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AA3CF;;AA8CA;EACE,UAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;AA3CF;;AAiDA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EAEA,iCAAA;EACA,mBAAA;AA/CF;;AAkDA;EACE,uBAAA;EACA,cAAA;AA/CF;;AAkDA;EACE,uBAAA;EACA,cAAA;AA/CF;;AAkDA;EACE,yBAAA;EACA,YAAA;AA/CF;;AAmDA;EACE,UAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,gDAAA;EACA,kBAAA,EAAA,uCAAA;AAhDF;;AAmDA;EACE,YAAA;EACA,aAAA;EACA,wDAAA;EACA,wBAAA;EACA,4BAAA;EACA,oBAAA,EAAA,mCAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;AAhDF;;AAmDA;EACE,UAAA;EAEA,YAAA;EAEA,YAAA;EAEA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,WAAA;EACA,kBAAA;AAnDF;;AA0DA;EACE,YAAA;EAEA,YAAA;EACA,mBAAA;EAEA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAzDF;;AA8DA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,iCAAA;AA3DF;;AA+DA;EACE,WAAA;EACA,aAAA;EAEA,wBAAA;EACA,2BAAA;AA7DF;;AAmEA;EACE,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,iCAAA;EACA,mBAAA;EACA,gBAAA;AAhEF;;AAqEA;EACE,YAAA;EAGA,mBAAA;EAEA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;AArEF;;AA0EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EAEA,gBAAA;EACA,cAAA;EACA,iCAAA;AAxEF;;AA4EA;EACE,YAAA;EACA,aAAA;EACA,wBAAA;AAzEF;;AA4EA;EACE,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,iCAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAzEF;;AA8EA;EAEE;IAEE,aAAA;EA7EF;EAyFA;IACE,eAAA;IACA,mBAAA;IACA,2BAAA;EAvFF;EA2FA;IACE,YAAA;EAzFF;EA4FA;IACE,eAAA;EA1FF;EA8FA;IACE,eAAA;EA5FF;EA+FA;IACE,aAAA;IACA,uBAAA;IACA,gBAAA;IACA,iBAAA;IACA,WAAA;EA7FF;AACF;AAkGA;EACE,UAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;AAhGF;;AAsGA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AAnGF;;AAsGA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EAEA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AApGF;;AAwGA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AArGF;;AA0GA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;AAvGF;;AA6GA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;AA1GF;;AA8GA;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;AA3GF;;AAgHA;EACE,UAAA;EACA,YAAA;EACA,wDAAA;EACA,wBAAA;EACA,4BAAA;EACA,iCAAA;AA7GF;;AAgHA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AA7GF;;AAiHA;EACE,gBAAA;EACA,qBAAA;AA9GF;;AAkHA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AA/GF;;AAkHA;EACE;IAEE,aAAA;EAhHF;AACF;AAqHA;EAEE;IACE,eAAA;IACA,mBAAA;IACA,gBAAA;EApHF;EAwHA;IACE,eAAA;IACA,YAAA;IACA,YAAA;EAtHF;EA2HA;IACE,eAAA;EAzHF;EA8HA;IACC,kBAAA;EA5HD;EA8HA;IACE,YAAA;EA5HF;EAkIA;IACE,eAAA;EAhIF;EAmIA;IACE,YAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,YAAA;EAjIF;EAmIA;IACE,YAAA;IACA,aAAA;IACA,gBAAA;EAjIF;EAsIA;IACE,YAAA;EApIF;EAwIA;IACE,eAAA;EAtIF;EAyIA;IACE,YAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,YAAA;EAvIF;EAyIA;IACE,YAAA;IACA,aAAA;EAvIF;EAiJA;IACE,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;IACA,SAAA,EAAA,gCAAA;IACA,mBAAA;EA/IF;EAkJA;;IAEE,WAAA;IACA,YAAA;IACA,wBAAA;IACA,4BAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,cAAA;IACA,mBAAA;IACA,gBAAA;EAhJF;EAmJA;;IAEE,eAAA;IACA,kBAAA;IACA,iBAAA;EAjJF;EAoJA;IACE,WAAA;IACA,uBAAA;EAlJF;EAqJA;IACE,UAAA;IACA,aAAA;IACA,2BAAA;IACA,wBAAA;IACA,4BAAA;EAnJF;AACF;AAuJA;EACE;IACE,YAAA;EArJF;EAwJA;IACE,eAAA;IACA,iBAAA;EAtJF;EAyJA;IACE,eAAA;EAvJF;EA0JA;IACE,eAAA;IACA,iBAAA;EAxJF;EA4JA;IAEE,aAAA;EA3JF;AACF;AAgLA;EACE,+BAAA;EACA,4BAAA;EACA,2BAAA;EACA,eAAA;AA9KF;AAgLE;EACE,yBAAA;EAGA,iCAAA;EACA,eAAA;AAhLJ;;AAoLA;EACE,eAAA;AAjLF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n\n\n}\n\n\n.uav {\n  width: 100%;\n  max-width: 100%;\n  position: relative;\n  height: 100%;\n  margin: 0 auto;\n  box-sizing: border-box;\n  overflow-x: hidden;\n\n}\n\n.uav-section-one {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n\n}\n\n@keyframes fadeInMini {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 0.7;\n    transform: translateY(0);\n  }\n}\n\n.mini-image {\n  position: absolute;\n  width: 240px;\n  height: auto;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 5;\n  animation: fadeInMini 1s ease forwards;\n}\n\n\n.top-right {\n  top: -3px;\n  right: 20px;\n}\n\n.bottom-right {\n  bottom: 20px;\n  right: 20px;\n}\n\n\n.navbar-uav {\n  transition: background 0.5s ease;\n  //margin-top: -100px;\n  display: flex;\n  width: 100%;\n\n}\n\n.uav-section-one {\n  width: 100%;\n  //height: 110vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-end;\n  transition: background 0.5s ease;\n  box-sizing: border-box;\n  margin-top: -2px;\n}\n\n.uav-image {\n  width: 100%;\n  max-width: 1400px;\n  height: 700px;\n  //margin: auto;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: right center;\n  aspect-ratio: 16 / 9;\n  transition: background-image 0.5s ease;\n}\n\n.uav-paragraphs {\n  width: 85%;\n  color: white;\n  margin-left: 100px;\n  font-size: 1.2rem;\n  text-align: start;\n  align-self: start;\n  border-radius: 8px;\n  //background-color: red;\n\n  display: flex;\n\n\n}\n\n.uav-paragraphs p {\n  font-weight: 700;\n  font-size: 48px;\n  line-height: 100%;\n  margin-top: -150px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.uav-paragraphs h1 {\n  font-size: 64px;\n  font-weight: 700;\n  line-height: 100%;\n  margin-left: 40px;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Background gradients */\n.bg-one {\n\n  //background: linear-gradient(to right, #A9AAAB, #252626);\n\n  background-image: url(\"https://i.imgur.com/0CBAAgA.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  //opacity: 0.9;\n  // //background: linear-gradient(to right, #79C095, #4C6D59);\n  //background-image: url(\"https://i.imgur.com/0CBAAgA.png\");\n  //background-size: cover;\n  //background-repeat: no-repeat;\n  //opacity: 0.9;\n}\n\n.bg-two {\n  background-image: url(\"https://i.imgur.com/0CBAAgA.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  //opacity: 0.9;\n}\n\n.bg-three {\n  //background: linear-gradient(to right, #79C095, #4C6D59);\n  //background-image: url(\"https://i.imgur.com/0CBAAgA.png\");\n  //background-size: cover;\n  //background-repeat: no-repeat;\n  //opacity: 0.9;\n  background-image: url(\"https://i.imgur.com/0CBAAgA.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  //opacity: 0.9;\n\n}\n\n.bg-for {\n  background-image: url(\"https://i.imgur.com/0CBAAgA.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  //opacity: 0.9;\n\n}\n\n.bg-five {\n  //background: linear-gradient(to right, #79C095, #4C6D59);\n  //background: linear-gradient(to right, #A9AAAB, #252626);\n\n  background-image: url(\"https://i.imgur.com/0CBAAgA.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  opacity: 0.9;\n}\n\n.bg-six {\n  //background: linear-gradient(to right, #A9AAAB, #252626);\n  background-image: url(\"https://i.imgur.com/0CBAAgA.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  //opacity: 0.9;\n}\n\n.uav-section-one {\n  background-image: url(\"https://i.imgur.com/Yrm4coY.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  overflow: hidden;\n}\n\n.bg-seven {\n  //background: linear-gradient(to right, #79C095, #4C6D59);\n\n  background-image: url(\"https://i.imgur.com/0CBAAgA.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  //opacity: 0.9;\n\n}\n\n\n.uav-section-one {\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.uav-background {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.uav-paragraph {\n  width: 70%;\n  margin: auto;\n  margin-top: 100px;\n  margin-bottom: 200px;\n  //height: 40vh;\n\n}\n\n\n.uav-paragraph p {\n  font-weight: 400;\n  font-size: 30px;\n  color: #252626;\n  line-height: 1.2;\n  //font-family:  'Inter', 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;\n  font-family: 'Roboto', sans-serif;;\n  text-align: justify;\n}\n\n.product-section button:hover {\n  background-color: white;\n  color: #191A1A;\n}\n\n.aw-5-section button:hover {\n  background-color: white;\n  color: #4C6D59;\n}\n\n.aw-6-section button:hover {\n  background-color: #4C6D59;\n  color: white;\n}\n\n\n.section {\n  width: 80%;\n  margin: auto;\n  height: 70vh;\n  margin-top: 200px;\n  background-color: #252626B2;\n  position: relative; /* Enable absolute positioning inside */\n}\n\n.aw5-horizonal-image {\n  width: 370px;\n  height: 360px;\n  background-image: url(\"https://i.imgur.com/9RhiUYc.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  transform: scaleX(1); /* Optional: Flip image if needed */\n  position: absolute;\n  top: -40px;\n  right: -180px;\n}\n\n.slider-section {\n  width: 80%;\n  //background-color: red;\n  margin: auto;\n  //height: 40vh;\n  height: auto;\n  //background-color: red;\n  margin-top: -85px;\n  margin-bottom: 100px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  z-index: 99;\n  position: relative;\n  //background-color: red;\n\n\n}\n\n\n.aw-5-section {\n  width: 400px;\n  //height: 400px;\n  margin: auto;\n  border-radius: 16px;\n  //height: 100%;\n  background: #4C6D59;\n  border: solid 3px white;\n  margin-bottom: 25px;\n\n}\n\n\n.aw-5-section p {\n  font-size: 46px;\n  margin-left: 50px;\n  margin-top: 40px;\n  font-weight: 700;\n  color: #ffffff;\n  font-family: 'Roboto', sans-serif;\n\n}\n\n.aw-5-section img {\n  width: 100%;\n  height: 250px;\n  //background-color: red;\n  background-size: contain;\n  background-position: center;\n\n\n\n}\n\n.aw-5-section button {\n  margin-left: 40px;\n  width: 80%;\n  border-radius: 32px;\n  border: 2px solid white;\n  color: white;\n  background-color: #4C6D59;\n  font-size: 32px;\n  font-family: 'Roboto', sans-serif;\n  margin-bottom: 20px;\n  font-weight: 500;\n\n}\n\n\n.aw-6-section {\n  width: 400px;\n  //height: 400px;\n  //height: 100%;\n  border-radius: 16px;\n\n  margin: auto;\n  background: white;\n  border: solid 3px #4C6D59;\n  margin-bottom: 25px;\n\n}\n\n\n.aw-6-section p {\n  font-size: 46px;\n  font-weight: 700;\n  margin-left: 50px;\n\n  margin-top: 40px;\n  color: #4C6D59;\n  font-family: 'Roboto', sans-serif;\n\n}\n\n.aw-6-section img {\n  width: 400px;\n  height: 250px;\n  background-size: contain;\n}\n\n.aw-6-section button {\n  margin-left: 40px;\n  width: 80%;\n  border-radius: 32px;\n  border: 2px solid #4C6D59;\n  background-color: white;\n  font-size: 32px;\n  font-family: 'Roboto', sans-serif;\n  margin-bottom: 20px;\n  color: #4C6D59;\n  font-weight: 500;\n\n}\n\n\n@media (max-width: 1000px) {\n\n  .uav-section-one {\n    //background-color: red;\n    height: 700px;\n    //background-size: 100px;\n  }\n\n\n\n\n  .bg-one {\n\n  }\n\n\n  .uav-image {\n    max-width: 100%;\n    aspect-ratio: 25 / 10; // Adjust as needed\n    background-position: center;\n\n  }\n\n  .mini-image {\n    width: 160px;\n  }\n\n  .uav-paragraphs p {\n    font-size: 32px;\n\n  }\n\n  .uav-paragraphs h1 {\n    font-size: 48px;\n  }\n\n  .uav-paragraphs {\n    display: flex;\n    justify-content: center;\n    margin-left: 0px;\n    padding-top: 60px;\n    width: 100%;\n\n  }\n}\n\n\n.product-section {\n  width: 80%;\n  height: 113px;\n  display: flex;\n  margin: auto;\n  background-color: #252626;\n  margin-bottom: 100px;\n  justify-content: space-around;\n  align-items: center;\n  flex-wrap: nowrap;\n\n\n\n}\n\n.product-section span {\n  color: white;\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n.product-section button {\n  width: 300px;\n  height: 66px;\n  border-radius: 32px;\n  border: solid white;\n\n  background-color: #252626;\n  color: white;\n  font-size: 32px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n\n.product-icons-section {\n  max-width: 800px;\n  width: 100%;\n  height: 100%;\n  display: flex;\n\n}\n\n\n.product-icon {\n  width: 115px;\n  height: 101px;\n  left: 362px;\n  background-image: url(\"../Images/product.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  display: flex;\n  margin: auto;\n  padding-top: 70px;\n\n\n}\n\n\n.galery-icon {\n  width: 115px;\n  height: 101px;\n  left: 362px;\n  background-image: url(\"../Images/galery.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  display: flex;\n  margin: auto;\n  padding-top: 70px;\n\n}\n\n.aw5-section {\n  width: 60%;\n  height: 100%;\n  display: flex;\n  justify-content: flex-end;\n\n\n}\n\n.aw-5-image {\n  width: 60%;\n  height: 100%;\n  background-image: url(\"https://i.imgur.com/onyLX1j.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: right center;\n}\n\n.product-icon p {\n  color: #4C6D59;\n  font-weight: 700;\n  font-size: 36px;\n\n}\n\n.product-icon a {\n  list-style: none;\n  text-decoration: none;\n\n}\n\n.galery-icon p {\n  color: #4C6D59;\n  font-weight: 700;\n  font-size: 36px;\n}\n\n@media (max-width: 1800px) {\n  .uav {\n    //max-width: 1500px;\n    width: 1800px;\n  }\n\n}\n\n\n@media (max-width: 1000px) {\n\n  .product-section span {\n    font-size: 16px;\n    margin-bottom: 20px;\n    margin-top: 22px;\n\n  }\n\n  .product-section button {\n    font-size: 16px;\n    height: 32px;\n    width: 100px;\n\n  }\n\n\n  .uav-paragraph p {\n    font-size: 24px;\n\n\n  }\n\n  .uav-paragraphs p{\n   margin-left: -10px;\n  }\n  .aw-5-section {\n    width: 210px;\n\n\n\n  }\n\n  .aw-5-section p {\n    font-size: 24px;\n  }\n\n  .aw-5-section button {\n    width: 120px;\n    font-size: 18px;\n    margin-left: 40px;\n    margin-top: 30px;\n    height: 30px;\n  }\n  .aw-5-section img {\n    width: 200px;\n    height: 150px;\n    margin-left: 7px;\n\n\n\n  }\n  .aw-6-section {\n    width: 210px;\n\n  }\n\n  .aw-6-section p {\n    font-size: 24px;\n  }\n\n  .aw-6-section button {\n    width: 120px;\n    font-size: 18px;\n    margin-left: 40px;\n    margin-top: 30px;\n    height: 30px;\n  }\n  .aw-6-section img {\n    width: 200px;\n    height: 150px;\n\n  }\n\n  .product-section {\n    //flex-direction: column; /* Flex ուղղությունը դարձնում ենք vertical */\n    //align-items: center; /* կենտրոնացնում ենք child-երը */\n    //height: auto; /* բարձրությունը թողնենք auto */\n  }\n\n  .product-icons-section {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: auto;\n    gap: 20px; /* icon-ների միջև տարածություն */\n    margin-bottom: 20px;\n  }\n\n  .product-icon,\n  .galery-icon {\n    width: 75px;\n    height: 65px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-top: 0;\n    margin-bottom: 50px;\n    margin-top: 40px;\n  }\n\n  .product-icon p,\n  .galery-icon p {\n    font-size: 24px;\n    text-align: center;\n    margin-top: 150px;\n  }\n\n  .aw5-section {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .aw-5-image {\n    width: 80%;\n    height: 300px;\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n  }\n}\n\n\n@media (max-width: 600px) {\n  .uav-section-one {\n    height: 60vh;\n    //background-position-x: -20px;\n  }\n  .uav-paragraphs p {\n    font-size: 18px;\n    padding-top: 65px;\n    //text-align: center;\n  }\n  .uav-paragraphs h1 {\n    font-size: 28px;\n  }\n\n  .uav-paragraph p {\n    font-size: 20px;\n    margin-top: -50px;\n    //text-align: start;\n//width: 300px;\n  }\n  .uav-section-one {\n    //background-color: red;\n    height: 250px;\n    //background-position-y: 1px;\n    //background-size: 100px;\n    //background-position-x: -14px;\n  }\n\n\n\n  //.uav-section-one {\n  //  background-image: url(\"https://i.imgur.com/WLiOjZH.png\");\n  //  background-size: contain;\n  //  background-repeat: no-repeat;\n  //  background-position: center;\n  //  overflow: hidden;\n  //\n  //}\n\n\n\n}\n\n\n.aw-5-section, .aw-6-section {\n  transition: transform 0.7s ease;\n  transform-style: preserve-3d;\n  backface-visibility: hidden;\n  cursor: pointer;\n\n  &:hover {\n    transform: rotateY(20deg);\n    //transform: rotatex(360deg);\n\n    box-shadow: 10px 10px 10px silver;\n    cursor: pointer;\n  }\n}\n\nbutton:hover {\n  cursor: pointer;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"uav": `Uav_uav__TLbUm`,
	"uav-section-one": `Uav_uav-section-one__+qXXF`,
	"mini-image": `Uav_mini-image__-af0C`,
	"fadeInMini": `Uav_fadeInMini__fPncr`,
	"top-right": `Uav_top-right__Nfiv6`,
	"bottom-right": `Uav_bottom-right__fFdas`,
	"navbar-uav": `Uav_navbar-uav__tUjXS`,
	"uav-image": `Uav_uav-image__9H7C4`,
	"uav-paragraphs": `Uav_uav-paragraphs__W5BBQ`,
	"bg-one": `Uav_bg-one__hc+eg`,
	"bg-two": `Uav_bg-two__RGggm`,
	"bg-three": `Uav_bg-three__GIOuW`,
	"bg-for": `Uav_bg-for__F2shc`,
	"bg-five": `Uav_bg-five__1G+Hm`,
	"bg-six": `Uav_bg-six__uHuTC`,
	"bg-seven": `Uav_bg-seven__wsXia`,
	"uav-background": `Uav_uav-background__G1gbr`,
	"uav-paragraph": `Uav_uav-paragraph__h1CSA`,
	"product-section": `Uav_product-section__yTo1h`,
	"aw-5-section": `Uav_aw-5-section__2Qf+u`,
	"aw-6-section": `Uav_aw-6-section__QuKsS`,
	"section": `Uav_section__zL39E`,
	"aw5-horizonal-image": `Uav_aw5-horizonal-image__EjAYM`,
	"slider-section": `Uav_slider-section__yrVA-`,
	"product-icons-section": `Uav_product-icons-section__UlYst`,
	"product-icon": `Uav_product-icon__Llkim`,
	"galery-icon": `Uav_galery-icon__7FpwZ`,
	"aw5-section": `Uav_aw5-section__hS5St`,
	"aw-5-image": `Uav_aw-5-image__UVwPt`
};
export default ___CSS_LOADER_EXPORT___;
